
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcceptUmbrellaCommercialContractRequest,
} from '../models';
import {
    AcceptUmbrellaCommercialContractRequestFromJSON,
    AcceptUmbrellaCommercialContractRequestToJSON,
} from '../models';

export interface AcceptUmbrellaCommercialContractOperationRequest {
    companyId: string;
    acceptUmbrellaCommercialContractRequest: AcceptUmbrellaCommercialContractRequest;
}

/**
 * 
 */
export class UmbrellaCommercialContractApi extends runtime.BaseAPI {

    /**
          */
    async acceptUmbrellaCommercialContractRaw(requestParameters: AcceptUmbrellaCommercialContractOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling acceptUmbrellaCommercialContract().'
            );
        }

        if (requestParameters['acceptUmbrellaCommercialContractRequest'] == null) {
            throw new runtime.RequiredError(
                'acceptUmbrellaCommercialContractRequest',
                'Required parameter "acceptUmbrellaCommercialContractRequest" was null or undefined when calling acceptUmbrellaCommercialContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/navbar/api/companies/{companyId}/umbrella-commercial-contract/acceptances`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptUmbrellaCommercialContractRequestToJSON(requestParameters['acceptUmbrellaCommercialContractRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async acceptUmbrellaCommercialContract(requestParameters: AcceptUmbrellaCommercialContractOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptUmbrellaCommercialContractRaw(requestParameters, initOverrides);
    }

}
